<template>
    <canvas :id="id" :width="width" :height="height"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
    props: {
        id: {
            type: String,
            required: true
        },
        data: {
            default() { return {} },
            type: Object
        },
        type: {
            default: "bar",
            type: String
        },
        width: {
            default: 400,
            type: Number
        },
        height: {
            default: 400,
            type: Number
        },
        options: {
            default() { return {} },
            type: Object
        },
    },
    data() {
        return {
            defaultOptions: {
                events: ['mousemove', 'click', 'touchstart', 'touchmove'],
                tooltips: {
                    custom: function(tooltipModel) {
                        let tooltipEl = document.getElementById('chartjs-tooltip');

                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.classList.add('tooltip', 'bs-tooltip-top', 'shadow', 'p-2', 'bg-dark', 'rounded-lg', 'text-white');
                            tooltipEl.innerHTML = '<table></table>';
                            document.body.appendChild(tooltipEl);
                        }

                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }

                        const data = this._chart.data;
                        const [dataPoints] = tooltipModel.dataPoints;
                        const getBody = (bodyItem) => {
                            const claims = data.datasets[dataPoints.datasetIndex] ? data.datasets[dataPoints.datasetIndex].claims[dataPoints.index] : '';

                            if (!claims) return bodyItem.lines;

                            return `${bodyItem.lines} <br/>${data.hoverLabel || 'Claims'}:<ul class="m-0 pl-4"><li>${claims.join('</li><li>')}</li></ul>`;
                        }


                        if (tooltipModel.body) {
                            const titleLines = tooltipModel.title || [];
                            const bodyLines = tooltipModel.body.map(getBody);
                            let innerHtml = '<thead>';
                            titleLines.forEach((title) => innerHtml += `<tr><th>${title}</th></tr>`);
                            innerHtml += '</thead><tbody>';

                            bodyLines.forEach(function(body, i) {
                                const colors = tooltipModel.labelColors[i];
                                const style = `display: inline-block; margin-right: 5px; width: 10px; height: 10px; border-width: 2px; background: ${colors.backgroundColor}; border-color: ${colors.borderColor}`;
                                const span = `<span style="${style}"></span>`;
                                innerHtml += `<tr><td>${span}${body}</td></tr>`;
                            });
                            innerHtml += '</tbody>';

                            const tableRoot = tooltipEl.querySelector('table');
                            tableRoot.innerHTML = innerHtml;
                        }

                        const position = this._chart.canvas.getBoundingClientRect();

                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.left = position.left + window.pageXOffset + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                    },
                    enabled: false,
                },
                legend: {
                    display: true,
                    // position: 'bottom',
                },
            }
        };
    },
    mounted() {
        const ctx = document.getElementById(this.id).getContext("2d");
        new Chart(ctx, {
            type: this.type,
            data: this.data,
            options: {
                ...this.defaultOptions,
                ...this.options
            },
        });
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports/chart.vue